(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.directive('validateOnClick', ['$timeout', '$compile', function ($timeout, $compile) {
			return {
				restrict: 'A',
				require: '^form',
				link: function (scope, element, attrs, form) {
					element.on('click', function () {
						angular.forEach(form.$error, function (field) {
							angular.forEach(field, function (errorField) {
								$timeout(function () { errorField.$setTouched() }, 0);
							})
						});
					})
				}
			}
		}]);
})();
